export default "__VITE_ASSET__FnCu7ku1__"